<div class="error">
  <div class="icon">
    <img src="assets/icon/background-yellow-close.svg" alt="" />
  </div>
  <div class="text">{{ error }}</div>
</div>
